var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgWebappViews = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: 12,
  height: 13,
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M1.92 4.251C2.93 3.307 4.37 2.437 6 2.437s3.07.87 4.08 1.814c.51.476.926.984 1.217 1.44.146.227.264.448.348.65.08.193.14.402.14.596 0 .195-.06.404-.14.597a4.24 4.24 0 0 1-.348.65 7.709 7.709 0 0 1-1.216 1.44C9.07 10.568 7.63 11.437 6 11.437c-1.63 0-3.07-.869-4.08-1.813a7.71 7.71 0 0 1-1.217-1.44 4.23 4.23 0 0 1-.347-.65 1.622 1.622 0 0 1-.142-.596c0-.195.062-.404.142-.597a4.23 4.23 0 0 1 .347-.65 7.71 7.71 0 0 1 1.216-1.44Zm5.794 2.686a1.714 1.714 0 1 1-3.428 0 1.714 1.714 0 0 1 3.428 0Z",
  fill: "#58636A"
})));
export default SvgWebappViews;